import React from 'react';
import { connect } from 'react-redux';
import { isSuperUser, isPatron } from '../lib/utils';

export default function withEditPermission(EditableComponent) {
  const mapStateToProps = ({ user }) => {
    const role = user.role && user.role;
    return {
      role,
      isPatron: isPatron(),
      isSuperUser: isSuperUser(),
    };
  };

  const EditableComponentWithPermission = props => <EditableComponent {...props} />;

  return connect(mapStateToProps)(EditableComponentWithPermission);
}



// WEBPACK FOOTER //
// ./src/HOCs/withEditPermission.jsx